import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import Loader from "../../components/Loader";
import { crmHeaders } from "../../utils/crmApi";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export default function EditSmsTemplate() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [countries, setCountries] = useState([]);
    const [template, setTemplate] = useState(null);
    const [loading, setLoading] = useState(true);
    const [submitting, setSubmitting] = useState(false);

    useEffect(() => {
        Promise.all([
            axios.get(`${BASE_URL}/getcountries`, { headers: crmHeaders() }),
            axios.get(`${BASE_URL}/sms/templates`, { headers: crmHeaders() }),
        ])
            .then(([countriesRes, templatesRes]) => {
                setCountries(countriesRes.data);
                const found = templatesRes.data.find((t) => String(t.Id) === String(id));
                setTemplate(found || null);
            })
            .catch(console.error)
            .finally(() => setLoading(false));
    }, [id]);

    const handleSubmit = (e) => {
        e.preventDefault();
        const formData = new FormData(e.target);
        const country = formData.get("country");
        const body = formData.get("template");

        setSubmitting(true);
        axios
            .put(
                `${BASE_URL}/sms/templates/${id}`,
                { Country: country, Template: body.trim() },
                { headers: crmHeaders() }
            )
            .then(() => navigate("/sms/templates"))
            .catch((err) => toast.error(err.response?.data?.message || "Update failed"))
            .finally(() => setSubmitting(false));
    };

    if (loading) return <Loader />;
    if (!template) {
        return (
            <div className="container">
                <p>Template not found.</p>
                <Link to="/sms/templates">Back</Link>
            </div>
        );
    }

    return (
        <div className="container">
            <ToastContainer />
            <div className="crm-page-header">
                <h1 className="crm-page-title">Edit SMS Template</h1>
                <Link to="/sms/templates" className="btn btn-outline-secondary">
                    Back
                </Link>
            </div>

            <form onSubmit={handleSubmit}>
                <div className="mb-3">
                    <label className="form-label">Country</label>
                    <select className="form-select" name="country" required defaultValue={template.Country}>
                        {countries
                            .filter((c) => c.Status === "Active")
                            .map((c) => (
                                <option key={c.Id} value={c.Country}>
                                    {c.Country}
                                </option>
                            ))}
                    </select>
                </div>
                <div className="mb-3">
                    <label className="form-label">Message Template</label>
                    <textarea
                        className="form-control"
                        name="template"
                        rows={6}
                        required
                        defaultValue={template.Template}
                    />
                </div>
                <button type="submit" className="btn btn-primary" disabled={submitting}>
                    {submitting ? "Updating..." : "Update Template"}
                </button>
            </form>
        </div>
    );
}
